// Packages
import Big from 'big.js'
import moment from 'moment'
// Helpers
import bobtailAPI from '../axiosConfig'
import Entity from './entity'
import {
  requestWithTransaction,
} from '../helpers'

const Invoice = new Entity('invoices')

// overwrite the Entity's get f()
Invoice.get = async (id) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/${id}`, {
    params: {
      include: 'all',
    },
  })
}

Invoice.getApprovedInvoices0to30DaysOldTotal = async (params, ISOString = null) => {
  const date = ISOString
    ? ISOString
    : moment(new Date()).startOf('day').toISOString()
  const to = 30
  const result = (await (await bobtailAPI()).get(`${Invoice.baseUrl}/get-total-client-aging`, {
    params: {
      cypressRequestID: ISOString
        ? `getApprovedInvoices0to30DaysOldTotal-${ISOString}`
        : 'getApprovedInvoices0to30DaysOldTotal',
      date,
      gt___approved_date: to,
      ...params, // must be last to overwrite if needed
    },
  })).data

  return new Big(result)
}

Invoice.getApprovedInvoices31to45DaysOldTotal = async (params, ISOString = null) => {
  const date = ISOString
    ? ISOString
    : moment(new Date()).startOf('day').toISOString()
  const from = 30
  const to = 45
  const result = (await (await bobtailAPI()).get(`${Invoice.baseUrl}/get-total-client-aging`, {
    params: {
      cypressRequestID: ISOString
        ? `getApprovedInvoices31to45DaysOldTotal-${ISOString}`
        : 'getApprovedInvoices31to45DaysOldTotal',
      date,
      gt___approved_date: to,
      lt___approved_date: from,
      ...params, // must be last to overwrite if needed
    },
  })).data

  return new Big(result)
}

Invoice.getApprovedInvoices46PlusDaysOldTotal = async (params, ISOString = null) => {
  const date = ISOString
    ? ISOString
    : moment(new Date()).startOf('day').toISOString()
  const from = 45
  const result = (await (await bobtailAPI()).get(`${Invoice.baseUrl}/get-total-client-aging`, {
    params: {
      cypressRequestID: ISOString
        ? `getApprovedInvoices46PlusDaysOldTotal-${ISOString}`
        : 'getApprovedInvoices46PlusDaysOldTotal',
      date,
      lt___approved_date: from,
      ...params, // must be last to overwrite if needed
    },
  })).data

  return new Big(result)
}

Invoice.getApprovedInvoices46to60DaysOldTotal = async (params, ISOString = null) => {
  const date = ISOString
    ? ISOString
    : moment(new Date()).startOf('day').toISOString()
  const from = 45
  const to = 60
  const result = (await (await bobtailAPI()).get(`${Invoice.baseUrl}/get-total-client-aging`, {
    params: {
      cypressRequestID: ISOString
        ? `getApprovedInvoices46to60DaysOldTotal-${ISOString}`
        : 'getApprovedInvoices46to60DaysOldTotal',
      date,
      gt___approved_date: to,
      lt___approved_date: from,
      ...params, // must be last to overwrite if needed
    },
  })).data

  return new Big(result)
}

Invoice.getApprovedInvoices61to90DaysOldTotal = async (params, ISOString = null) => {
  const date = ISOString
    ? ISOString
    : moment(new Date()).startOf('day').toISOString()
  const from = 60
  const to = 90
  const result = (await (await bobtailAPI()).get(`${Invoice.baseUrl}/get-total-client-aging`, {
    params: {
      cypressRequestID: ISOString
        ? `getApprovedInvoices61to90DaysOldTotal-${ISOString}`
        : 'getApprovedInvoices61to90DaysOldTotal',
      date,
      gt___approved_date: to,
      lt___approved_date: from,
      ...params, // must be last to overwrite if needed
    },
  })).data

  return new Big(result)
}

Invoice.getApprovedInvoices91PlusDaysOldTotal = async (params, ISOString = null) => {
  const date = ISOString
    ? ISOString
    : moment(new Date()).startOf('day').toISOString()
  const from = 90
  const result = (await (await bobtailAPI()).get(`${Invoice.baseUrl}/get-total-client-aging`, {
    params: {
      cypressRequestID: ISOString
        ? `getApprovedInvoices91PlusDaysOldTotal-${ISOString}`
        : 'getApprovedInvoices91PlusDaysOldTotal',
      date,
      lt___approved_date: from,
      ...params, // must be last to overwrite if needed
    },
  })).data

  return new Big(result)
}

Invoice.getApprovedInvoicesTotalDaysOldTotal = async (params, ISOString = null) => {
  const date = ISOString
    ? ISOString
    : moment(new Date()).startOf('day').toISOString()
  const result = (await (await bobtailAPI()).get(`${Invoice.baseUrl}/get-total-client-aging`, {
    params: {
      cypressRequestID: ISOString
        ? `getApprovedInvoicesTotalDaysOldTotal-${ISOString}`
        : 'getApprovedInvoicesTotalDaysOldTotal',
      date,
      ...params, // must be last to overwrite if needed
    },
  })).data

  return new Big(result)
}

Invoice.getAvgVolumeAggregate = async (params) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/volume-average-aggregate`, {
    params,
  })
}

Invoice.getAvgClientsVolumeAggregate = async (params) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/volume-average-clients-aggregate`, {
    params,
  })
}

Invoice.getAvgDebtorsVolumeAggregate = async (params) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/volume-average-debtors-aggregate`, {
    params,
  })
}

Invoice.getBatchReport = async (params) => {
  return requestWithTransaction(
    'batch-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/batch-report`, {
        params,
      })
    }
  )
}

Invoice.getBuyoutJournalEntries = async (params) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/buyout-journal-entries`, {
    params,
  })
}

Invoice.getClientAccountSummaryReport = async (params) => {
  return requestWithTransaction(
    'client-account-summary-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/client-account-summary`, {
        params,
      })
    }
  )
}

Invoice.getClientAgingGeneralReport = async (params) => {
  return requestWithTransaction(
    'client-aging-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/client-aging-general`, {
        params,
      })
    }
  )
}

Invoice.getClientBankAccountsReport = async (params) => {
  return requestWithTransaction(
    'client-bank-accounts-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/client-bank-accounts-report`, {
        params,
      })
    }
  )
}

Invoice.getClientReservesAccountReport = async (params) => {
  return requestWithTransaction(
    'client-reserves-account-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/client-reserves-account-report`, {
        params,
      })
    }
  )
}

Invoice.getClientListReport = async (params) => {
  return requestWithTransaction(
    'client-list-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/client-list`, {
        params,
      })
    }
  )
}

Invoice.getPortfolioReserves = async (params) => {
  return requestWithTransaction(
    'portfolio-reserves-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/portfolio-reserves`, {
        params,
      })
    }
  )
}

Invoice.getClientStatusChangeReport = async (params) => {
  return requestWithTransaction(
    'client-status-change-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/client-status-change-report`, {
        params,
      })
    }
  )
}

Invoice.getClientSummary = async (params) => {
  return requestWithTransaction(
    'client-summary-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/client-summary`, {
        params,
      })
    }
  )
}

Invoice.getClientTrends = async (params) => {
  return requestWithTransaction(
    'client-trends-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/client-trends`, {
        params,
      })
    }
  )
}

Invoice.getDebtorAgingGeneralReport = async (params) => {
  return requestWithTransaction(
    'debtor-aging-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/debtor-aging-general`, {
        params,
      })
    }
  )
}

Invoice.getDebtorStatusChangeReport = async (params) => {
  return requestWithTransaction(
    'debtor-status-change-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/debtor-status-change-report`, {
        params,
      })
    }
  )
}

Invoice.getDebtorPaymentReport = async (params) => {
  return requestWithTransaction(
    'debtor-payment-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/debtor-payment-report`, {
        params,
      })
    }
  )
}

Invoice.getDebtorRatingsReport = async (params) => {
  return requestWithTransaction(
    'debtor-ratings-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/debtor-ratings-report`, {
        params,
      })
    }
  )
}

Invoice.getDetailedAgingReport = async (params) => {
  return requestWithTransaction(
    'detailed-aging-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/detailed-aging`, {
        params,
      })
    }
  )
}

Invoice.getInvoiceReport = async (params) => {
  return requestWithTransaction(
    'invoice-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/invoice-report`, {
        params,
      })
    }
  )
}

Invoice.getInvoiceTransferTypesReport = async (params) => {
  return requestWithTransaction(
    'invoice-transfer-types',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/invoice-transfer-type-report`, {
        params,
      })
    }
  )
}

Invoice.getLoanTapeReport = async (params) => {
  return requestWithTransaction(
    'loan-tape-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/loan-tape`, {
        params,
      })
    }
  )
}

// params: start date, end date (date object)
// output: total_approved_accounts_receivable_amount, count, clients
Invoice.getNewClientsVolumeAggregate = async (params) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/volume-new-clients-aggregate`, {
    params,
  })
}

Invoice.getPortfolioReport = async (params) => {
  return requestWithTransaction(
    'portfolio-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/portfolio-report`, {
        params,
      })
    }
  )
}

Invoice.getPossibleDuplicates = async (params) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/possible-duplicates`, {
    params,
  })
}

Invoice.getReleasedCompanyCount = async (params) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/volume-total-clients-released`, {
    params,
  })
}

Invoice.getRollForwardReport = async (params) => {
  return requestWithTransaction(
    'roll-forward-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/roll-forward`, {
        params,
      })
    }
  )
}

Invoice.getNetFundsEmployed = async (params) => {
  return requestWithTransaction(
    'net-funds-employed-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/net-funds-employed`, {
        params,
      })
    }
  )
}

Invoice.getReconciliationReport = async (params) => {
  return requestWithTransaction(
    'reconciliation-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/reconciliation-report`, {
        params,
      })
    }
  )
}

Invoice.getSalesforceReconciliationReport = async (params) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/salesforce-reconciliation-report`, {
    params,
  })
}

Invoice.getTotalClientsAggregate = async (params) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/volume-total-clients-aggregate`, {
    params,
  })
}

Invoice.getUpdateStats = async (params) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/update-statistics`, {
    params,
  })
}

// params: start date, end date (pass a date object)
// ouput: total_approved_accounts_receivable_amount
Invoice.getVolumeAggregate = async (params) => {
  return (await bobtailAPI()).get(`${Invoice.baseUrl}/volume-aggregate`, {
    params,
  })
}

Invoice.getVolumeReport = async (params) => {
  return requestWithTransaction(
    'volume-report',
    'report',
    async () => {
      return (await bobtailAPI()).get(`${Invoice.baseUrl}/volume-report`, {
        params,
      })
    }
  )
}

Invoice.postBuyoutJournalEntries = async (params) => {
  return (await bobtailAPI()).post(`${Invoice.baseUrl}/buyout-journal-entries`, {
    ...params,
  })
}

export default Invoice
